import { IApplicationState } from '../../../../../types/types';
import { IDependency, TDependencyId } from '../../dependency/types';

export const getCardDependency = (
    state: IApplicationState,
    id: TDependencyId,
): IDependency => {
    return state.model.dependencies && state.model.dependencies[id] ? state.model.dependencies[id] : null;
}
